import axios from "axios";
import { HttpJsonHeader } from "../../features/Environments";
import { BlobToBase64 } from "../../core/Helper";

export class ClipboardHelper {
  props = {};

  constructor(props) {
    this.props = props;
  }

  blobToBase64 = (blob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  };

  getClipboard = (data) =>
    new Promise(async (resove, reject) => {
      const { userDetail, selectedRow } = this.props;

      const permission = await navigator.permissions.query({
        name: "clipboard-read",
      });

      //   if (permission.state === "granted") {
      //     const clipboardContents = await navigator.clipboard.read();
      //     for (const item of clipboardContents) {
      //       if (!item.types.includes("image/png")) {
      //         reject({ result: false, info: "Not an Image Type" });
      //       }

      //       const blob = await item.getType("image/png");
      //       const formData = new FormData();
      //       let imageData = await this.blobToBase64(blob);
      //       formData.append(
      //         "user",
      //         JSON.stringify({ ...userDetail, uploadType: 2 })
      //       ); // uploadType(1=file, 2=captured image, 3=scanned image)
      //       formData.append("rowdata", JSON.stringify(selectedRow));
      //       formData.append("image", JSON.stringify({ image: imageData }));

      //       let upload = await axios.post(
      //         process.env.REACT_APP_API +
      //           "api/studyinfo/study-update-web-capture",
      //         formData,
      //         HttpJsonHeader
      //       );
      //       console.log(upload);
      //       resove("OK");
      //     }
      //   }
    });
}

export const ClipboardImageHelper = (props) =>
  new Promise(async (resolve, reject) => {
    const { userDetail, selectedRow } = props;

    const permission = await navigator.permissions.query({
      name: "clipboard-read",
    });

    if (permission.state === "granted") {
      const clipboardContents = await navigator.clipboard.read();

      for (const item of clipboardContents) {
        if (!item.types.includes("image/png")) {
          reject("no-image");
          return;
        }

        const blob = await item.getType("image/png");
        const formData = new FormData();
        let imageData = await BlobToBase64(blob);
        formData.append(
          "user",
          JSON.stringify({ ...userDetail, uploadType: 2 })
        ); // uploadType(1=file, 2=captured image, 3=scanned image)
        formData.append("rowdata", JSON.stringify(selectedRow));
        formData.append("image", JSON.stringify({ image: imageData }));

        axios
          .post(
            process.env.REACT_APP_API +
              "api/studyinfo/study-update-web-capture",
            formData,
            HttpJsonHeader
          )
          .then((result) => {
            //console.log(result);
            resolve("ok");
          })
          .catch((err) => {
            console.log(err);
            reject("no-image");
          });
      }
    }
  });
